<template>
  <div class="p-i-invested-standard-list-panel">
    <div class="p-i-invested-standard-list-panel__heaer">
      <SmallText :size="textSize(16)">
        <slot name="heading" />
      </SmallText>
    </div>
    <div class="p-i-invested-standard-list-panel__body">
      <p>
        <SmallText :size="textSize(18)" weight="bold" color="#616161">
          <slot name="content" />
        </SmallText>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { mapState } from "vuex";
import { Options, Vue } from 'vue-class-component';
import globals from "@/general/store/modules/globals";

import SmallText from "@/common/components/atoms/SmallText.vue";

@Options({
  components: {
    SmallText
  }
})
export default class IInvestedStandardListPanel extends Vue {
  get textSize() {
    const isSp = globals.isSpScreenWidth;
    return (textSize: number) => (isSp ? textSize - 2 : textSize);
  }
}
</script>

<style lang="scss" scoped>
.p-i-invested-standard-list-panel {
  @include large-pc {
    padding: rem(8) rem(24);
  }

  &__header {
  }

  &__body {
    @include large-pc {
      margin-top: rem(4);
    }
  }
}
</style>
